/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ObjectObjectConfiguration as __Configuration } from '../object-object-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class PageService extends __BaseService {
  static readonly getMenuListPath = '/page';
  static readonly getPageMenuPath = '/page/{slug}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Get Menu list in page.
   * @param lang Language short code.
   */
  getMenuListResponse(lang?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (lang != null) __params = __params.set('lang', lang.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/page`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get Menu list in page.
   * @param lang Language short code.
   */
  getMenuList(lang?: string): __Observable<null> {
    return this.getMenuListResponse(lang).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Get Menu in page with slug.
   * @param params The `PageService.GetPageMenuParams` containing the following parameters:
   *
   * - `slug`: slug of page.
   *
   * - `lang`: Language short code.
   */
  getPageMenuResponse(params: PageService.GetPageMenuParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.lang != null) __params = __params.set('lang', params.lang.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/page/${encodeURIComponent(String(params.slug))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Get Menu in page with slug.
   * @param params The `PageService.GetPageMenuParams` containing the following parameters:
   *
   * - `slug`: slug of page.
   *
   * - `lang`: Language short code.
   */
  getPageMenu(params: PageService.GetPageMenuParams): __Observable<null> {
    return this.getPageMenuResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module PageService {

  /**
   * Parameters for getPageMenu
   */
  export interface GetPageMenuParams {

    /**
     * slug of page.
     */
    slug: string;

    /**
     * Language short code.
     */
    lang?: string;
  }
}

export { PageService }
